import styled from "styled-components"
import media from "styled-media-query"

export const BlogPostContainer = styled.div`
  padding: 0 1em;
  padding-top: 1em;
  padding-bottom: 1em;

  ${media.greaterThan("medium")`
    padding: 0 3.5em;
    padding-top: 1em;
    padding-bottom: 5em;
  `}
`

export const BlogPostInfo = styled.div`
  font-style: italic;
  margin-bottom: 2em;
  text-align: center;
`

export const BlogPostTitle = styled.h1`
  font-size: 2.25em;
  font-style: normal;
  line-height: 1em;
  margin-bottom: 0.5em;

  ${media.greaterThan("medium")`
    font-size: 2.8em;
    line-height: 1.2em;
  `}

  ${media.greaterThan("huge")`
    font-size: 2.8em;
    line-height: 1.4em;
  `}
`

export const BlogPostDate = styled.time`
  font-style: italic;
`

export const BlogPostLengthTime = styled.span`
  font-style: italic;
`

export const BlogPostCategory = styled.p`
  /* font-size: 1.1rem;
  padding: 0.5em 0 1em; */
  text-align: center !important;
`
export const BlogPostContent = styled.div`
  color: inherit;

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 1em 0;
  }

  figcaption {
    color: ${props => props.theme.colors.caption};
  }

  p {
    color: ${props => props.theme.colors.light};
    /* font-weight: 400;
    line-height: 1.8;
    margin-bottom: 0.5em; */
    text-align: justify;
  }

  ul {
    list-style-type: disc;
    margin-left: 1.5em;
    margin-bottom: 0.5em;
  }

  li {
    margin-bottom: 0.75em;
  }

  img {
    /* width: auto;
    max-width: 80%; */
    background-color: transparent;
    text-align: center;
    margin-top: 1em;
    margin-bottom: 2em;
    max-width: 100%;
  }

  a {
    color: ${props => props.theme.colors.highlight};
    font-weight: 400;

    &:hover {
      text-decoration: underline;
    }
  }
`
